import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';

export const getFuelSetup = createAsyncThunk(
    'fuel/getFuelSetup',
    async ({ assetId, userid }, thunkAPI) => {
        if (assetId) {
            try {
                const reqData = { imei: assetId, userid };
                const apiData = await apiClient.post('/fuel_get_setup', reqData);
                if (apiData.data.error) {
                    return thunkAPI.rejectWithValue(apiData.data.error);
                } else {
                    return { ...apiData.data.result, valid: apiData.data.valid };
                }

            } catch (error) {
                return thunkAPI.rejectWithValue(error);
            }
        } else {
            return 'not_loaded';
        }
    }
)

export const createSetup = createAsyncThunk(
    'fuel/createSetup',
    async ({ assetId, vehicleName, userid, noOfSensors, noOfTanks, vehicleType, make, model }, thunkAPI) => {
        try {
            const reqData = {
                imei: assetId, vehicleName, userid,
                noOfSensors, noOfTanks, vehicleType, make, model,
                sensors: Array(parseInt(noOfSensors)).fill({ status: 'empty' }),
                tanks: Array(parseInt(noOfTanks)).fill({ status: 'empty' }),
            };
            const apiData = await apiClient.post('/fuel_create_setup', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, setupId: apiData.data.insertId };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const addSensor = createAsyncThunk(
    'fuel/addSensor',
    async ({ setupId, assetId, sensorIndex, sensorParam, sensorSerial, sensorMac, sensorBrand, manufacturerSerial }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, setupId, sensorIndex, sensorParam, sensorSerial, sensorMac, sensorBrand, manufacturerSerial };
            const apiData = await apiClient.post('/fuel_add_sensor', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, sensorIndex, sensorId: apiData.data.sensorId };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const addTank = createAsyncThunk(
    'fuel/addTank',
    async ({ assetId, userid, name, tankIndex, setupId, noOfSensors, content, volume, expectedMileage, expectedHourly, minFillThreshold, minTheftThreshold, tuningParams }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid, name, tankIndex, setupId, noOfSensors, content, volume, expectedMileage, expectedHourly, minFillThreshold, minTheftThreshold, tuningParams };
            const apiData = await apiClient.post('/fuel_add_tank', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, tankIndex, tankId: apiData.data.tankId };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const editTank = createAsyncThunk(
    'fuel/editTank',
    async ({ assetId, userid, setupId, tankId, name, tankIndex, content, volume, expectedMileage, expectedHourly, minFillThreshold, minTheftThreshold, tuningParams }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid, setupId, tankId, name, tankIndex, content, volume, expectedMileage, expectedHourly, minFillThreshold, minTheftThreshold, tuningParams };
            //console.log("Tank Edit reqData", reqData);
            const apiData = await apiClient.post('/fuel_edit_tank', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, success: apiData.data.result };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const tankMapSensor = createAsyncThunk(
    'fuel/tankMapSensor',
    async ({ assetId, tankId, sensorList, aggregationMethod }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, tankId, sensorList, aggregationMethod };
            const apiData = await apiClient.post('/fuel_tank_mapsensor', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, success: apiData.data.result };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const finalizeSetup = createAsyncThunk(
    'fuel/finalizeSetup',
    async ({ assetId, userid }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid };
            const apiData = await apiClient.post('/fuel_finalize_setup', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, setup: apiData.data.setup };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const createEvents = createAsyncThunk(
    'fuel/createEvents',
    async ({ assetId, userid, notify_system, notify_email, notify_email_address, notify_sms, notify_sms_number }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid, notify_system, notify_email, notify_email_address, notify_sms, notify_sms_number };
            const apiData = await apiClient.post('/fuel_create_events', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, eventId: apiData.data.eventId };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const editNotification = createAsyncThunk(
    'fuel/editNotification',
    async ({ assetId, userid, notify_system, notify_email, notify_email_address, notify_sms, notify_sms_number }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid, notify_system, notify_email, notify_email_address, notify_sms, notify_sms_number };
            const apiData = await apiClient.post('/fuel_edit_notifications', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, success: apiData.data.result };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const changeDevice = createAsyncThunk(
    'fuel/changeDevice',
    async ({ assetId, oldImei, userid }, thunkAPI) => {
        try {
            const reqData = { newImei: assetId, oldImei, userid };
            const apiData = await apiClient.post('/fuel_change_imei', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, oldImei: oldImei, setup: apiData.data.setup };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


//tested till here
export const deleteSetup = createAsyncThunk(
    'fuel/deleteSetup',
    async ({ assetId, userid }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid };
            const apiData = await apiClient.post('/fuel_delete_setup', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, success: apiData.data.result };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);



export const deleteSensor = createAsyncThunk(
    'fuel/deleteSensor',
    async ({ assetId, userid, sensorIndex }, thunkAPI) => {
        try {
            const reqData = { imei: assetId, userid, sensorIndex };
            const apiData = await apiClient.post('/fuel_delete_sensor', reqData);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            } else {
                return { assetId, success: apiData.data.result };
            }

        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);


